import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.79198 2.938C6.50386 2.47904 9.24953 2.24889 12 2.25C14.797 2.25 17.54 2.486 20.209 2.938C20.6413 3.01266 21.0333 3.238 21.3154 3.57408C21.5974 3.91015 21.7514 4.33525 21.75 4.774V5.818C21.7498 6.61359 21.4336 7.37653 20.871 7.939L14.689 14.121C14.5497 14.2604 14.4393 14.4258 14.3639 14.6078C14.2886 14.7899 14.2499 14.985 14.25 15.182V18.109C14.2501 18.6662 14.0951 19.2125 13.8023 19.6865C13.5094 20.1606 13.0903 20.5437 12.592 20.793L10.835 21.671C10.7206 21.7281 10.5936 21.755 10.4659 21.7492C10.3383 21.7434 10.2142 21.7051 10.1055 21.6379C9.9968 21.5706 9.90708 21.4768 9.84486 21.3651C9.78264 21.2535 9.74998 21.1278 9.74998 21V15.182C9.74963 14.7843 9.59136 14.403 9.30998 14.122L3.12998 7.938C2.56733 7.37553 2.25115 6.61259 2.25098 5.817V4.774C2.25098 3.877 2.88998 3.091 3.79198 2.938Z"
        fill={colorValue}
      />
    </svg>
  );
};
